import type { ProfileV2 } from '../../types';

function hasRoleFoundInCV({ workHistories }: ProfileV2): boolean {
  return workHistories.some((workHistory) => workHistory.foundInCV);
}

// Todo - convert this to a named export
// eslint-disable-next-line import/no-default-export
export default hasRoleFoundInCV;
